import React from "react";

import bustleStackedLockupBlue from "assets/images/bustle/StackedLockUpCoolBlueBigBVersion@0.5.png";
import { ReactComponent as PosBossCloud } from "assets/images/posBossCloud.svg";
import { Trans, useTranslation } from "react-i18next";

import Icon from "Atoms/Icons";
import type { IconProps } from "Atoms/Icons";
import { WithLoadingComponent } from "Atoms/Loading";

import { VenueErrorPage } from "./ErrorPage";

type windowVenueName = {
  venueName: string;
};
export const LoadingPage = () => {
  const { t } = useTranslation("onsite");
  const venueName = (window as { venueName?: string }).venueName;
  return (
    <div className="h-screen overflow-y-hidden bg-bustle-cream">
      <div className="mx-auto flex h-screen w-full max-w-screen-sm flex-col items-center justify-center space-y-48 overflow-y-auto">
        <img
          src={bustleStackedLockupBlue}
          alt="Bustle"
          className="h-192 w-auto max-w-xs animate-small-bounce"
        />
        <h3 className="text-center text-xl">
          {venueName ? (
            <Trans
              i18nKey="common.loadingVenue"
              values={{ venueName }}
              shouldUnescape
            />
          ) : (
            t("common.loading")
          )}
        </h3>
      </div>
    </div>
  );
};

export const LoadingSpinner = ({ ...props }: Partial<IconProps>) => {
  return (
    <Icon
      color={"current"}
      size={undefined}
      icon="loading"
      className="inline-block animate-spin align-middle"
      {...props}
    />
  );
};

const Loading = WithLoadingComponent(
  () => (
    <div>
      <LoadingPage />
    </div>
  ),
  () => (
    <div>
      <VenueErrorPage resetError={() => {}} errorMessage="Error" />
    </div>
  ),
);
export const isLoading = (status: ("error" | "pending" | "success")[]) => {
  return status.some((s) => s === "pending");
};

export { useLoadingState } from "Atoms/Loading";
export default Loading;
